import React, { useState } from "react";
import styled from "styled-components";
import { SCREEN_WIDTH_BREAKPOINT } from "constant/common_constants";
import MainNavItem from "../MainNavItem";
import { NAV_ELEMENTS } from "constant/navigation";
import DotsLine from "components/common/view_util/DotsLine";
import { useParams } from "react-router-dom";
import MainNavGroup from "../MainNavGroup";
import { DL_GROUPS } from "constant/dl_group/dl_group.constant";

export default function GroupNavigation() {
  const { slug } = useParams();

  if (!slug) {
    return <></>;
  }

  return (
    <>
      <MainNavGroup>
        <MainNavItem
          navElement={{ path: `/g/${slug}`, title: DL_GROUPS[slug].linkLabel }}
        />
        <MainNavItem
          navElement={{
            path: `/g/${slug}/kd`,
            title: "izložbeni katalozi",
          }}
        />
        <MainNavItem
          navElement={{
            path: `/g/${slug}/d`,
            title: "knjige",
          }}
        />
        <MainNavItem
          navElement={{
            path: `/g/${slug}/p`,
            title: "periodika",
          }}
        />
        <MainNavItem
          navElement={{
            path: `/g/${slug}/hm`,
            title: "hemeroteka",
          }}
        />
        <MainNavItem
          navElement={{
            path: `/g/${slug}/photo-series/ph`,
            title: "fotodokumentacija",
          }}
        />
        <MainNavItem
          navElement={{
            path: `/g/${slug}/photo-series/ng`,
            title: "neknjižna građa",
          }}
        />
      </MainNavGroup>
      <DotsLine />
    </>
  );
}

const Div = styled.div`
  display: none;
  flex-direction: column;
  margin-top: 0;
  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    &&& {
      display: flex;
    }
  }
`;
